// Module
var code = "<ng-transclude></ng-transclude> ";
// Exports
export default code;